import { Component } from '@angular/core';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
    standalone: false
})
export class LogoutComponent{
  public get isExpired(): string {
    return sessionStorage.getItem('session_expired');
  }
  
}
